var FeedStateEvent = /* @__PURE__ */ ((FeedStateEvent2) => {
  FeedStateEvent2["LOADING_START"] = "feed:loading:start";
  FeedStateEvent2["LOADING_END"] = "feed:loading:end";
  FeedStateEvent2["EMPTY_SHOWN"] = "feed:empty:shown";
  FeedStateEvent2["PAGINATION_LOADED"] = "feed:pagination:loaded";
  FeedStateEvent2["ANNOUNCEMENT"] = "feed:announcement";
  return FeedStateEvent2;
})(FeedStateEvent || {});
export {
  FeedStateEvent
};
//# sourceMappingURL=_types.js.map
